import React from "react";
import FilterOptions from "./FilterOptions";
import { normalizeOptions } from "./helpers";
import { ALL_VALUE, ICommonFilterProps } from "./types";

type TProps<TQuery extends string> = ICommonFilterProps<TQuery> & {
    value: string[] | null;
    onChange: (value: string | string[] | null) => void;
};

const CommonFilter = <TQuery extends string>({
    name,
    labelPrefix,
    options,
    trackEventName,
    multiSelect = false,
    value,
    onChange,
    iconType
}: TProps<TQuery>): JSX.Element => {
    const normalizedOptions = normalizeOptions(labelPrefix, options, multiSelect);

    return (
        <FilterOptions
            filters={normalizedOptions.map(option => ({
                nestedFilters: option.nestedFilters,
                label: option.label,
                value: option.value,
                isAll: option.isAll,
                checked: !!value?.find(s => s === option.value),
                onClick: () => {
                    if (multiSelect) {
                        if (value?.includes(option.value)) {
                            let newValue = value.filter(s => s !== option.value);
                            // if all option is included, remove it
                            if (value.find(s => s === ALL_VALUE)) {
                                newValue = newValue.filter(s => s !== ALL_VALUE);
                            }
                            onChange(newValue);
                        } else {
                            onChange([...(value || []), option.value]);
                        }
                    } else {
                        onChange(value?.includes(option.value) ? null : option.value);
                    }
                },
                trackEventName,
                trackEventData: { option: option.value, param: name }
            }))}
            handleSelectAll={multiSelect ? () => onChange(normalizedOptions.map(option => option.value)) : undefined}
            handleSelectNone={multiSelect ? () => onChange(null) : undefined}
            iconType={iconType}
        />
    );
};

export default CommonFilter;
